import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';
import { COPY } from '../copy';
import { PageHeading } from '../shell/PageHeading';
import { usePageTitle } from '../shell/usePageTitle';

const SECTIONS = {
  todo: { title: COPY.navTodo, body: COPY.todoComingSoonBody },
  tracking: { title: COPY.navTracking, body: COPY.trackingComingSoonBody },
} as const;

export function ComingSoonPage({ section }: { section: keyof typeof SECTIONS }) {
  const { title, body } = SECTIONS[section];
  usePageTitle(title);

  return (
    <Container maxWidth="sm" sx={{ py: { xs: 4, lg: 8 } }}>
      <PageHeading>{title}</PageHeading>
      <Chip label={COPY.comingSoon} size="small" variant="outlined" sx={{ mb: 2 }} />
      <Typography variant="body1" sx={{ mb: 3 }}>
        {body}
      </Typography>
      <Button variant="contained" component={RouterLink} to="/start" nativeButton={false}>
        {COPY.goToStart}
      </Button>
    </Container>
  );
}
